import React from 'react';
import StyledTable from '@shared/components/StyledTable';
import { Close as CloseIcon } from '@mui/icons-material';
import DownloadFile from './DownloadFile';
import { userInfo } from '@apollo-internal/cache';
import { useReactiveVar } from '@apollo/client';
import PrivilegeNames from '../../../constants/privilegeNames';

/**
 * @typedef {object} LegalDocumentsTableProps
 * @property {boolean} [loading]
 * @property {Array<*>} [data]
 * @property {(id: number) => void} [onDelete]
 */

/**
 * @param {LegalDocumentsTableProps} props
 */
const LegalDocumentsTable = props => {
  const { data, loading, onDelete } = props;
  const currentUserInfo = useReactiveVar(userInfo);
  const canDowloadLegalDocument = currentUserInfo.Privileges.includes(
    PrivilegeNames.LegalDocuments_AccessDocuments
  );
  const canDeleteLegalDocument = currentUserInfo.Privileges.includes(
    PrivilegeNames.LegalDocuments_Delete
  );

  const COLUMNS = [
    {
      title: 'Org Unit',
      dataIndex: 'orgUnits',
      width: '35%',
      sorter: (a, b) => a.orgUnits.localeCompare(b.orgUnits)
    },
    {
      title: 'Document',
      dataIndex: 'fileName',
      width: '35%',
      sorter: (a, b) => a.fileName.localeCompare(b.fileName),
      render(value, record) {
        return canDowloadLegalDocument ? <DownloadFile document={record} text={value} /> : value;
      }
    },
    {
      title: 'Completed Date',
      dataIndex: 'completedDate',
      width: '20%',
      sorter: (a, b) => Number(new Date(a.completedDate)) - Number(new Date(b.completedDate))
    },
    {
      title: 'Remove',
      dataIndex: 'remove',
      width: '10%',
      render: (_, record) => {
        return (
          <CloseIcon
            className='remove-document-icon'
            data-testid={`remove-document-${record.id}`}
            onClick={() => onDelete(record.id)}
          />
        );
      },
      hidden: !canDeleteLegalDocument
    }
  ].filter(column => !column.hidden);

  return (
    <div className='legal-documents-table-container'>
      <StyledTable
        className='legal-documents-table'
        rowKey='id'
        dataSource={data}
        columns={COLUMNS}
        showSorterTooltip={false}
        loading={loading}
        pagination={false}
      />
    </div>
  );
};

export default LegalDocumentsTable;
